import Icon from '@ant-design/icons';
import React from 'react';

function CompetitorsSvg() {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.08044 6.28436C9.58017 6.81158 10.3323 7.15639 11.1418 7.15639H11.2793C11.9564 7.15639 12.7035 6.84906 13.0783 6.42929C13.1283 6.37432 13.8304 7.17388 15.2621 7.15639H15.3995C16.0916 7.15639 16.6738 6.91652 16.9912 6.49425C17.3085 6.07198 17.3385 5.38485 17.0561 4.96008L15.5844 2.27903C15.5744 2.25905 15.5619 2.24405 15.5494 2.22906C15.4645 2.08914 15.2671 1.98419 15.1047 1.99419H9.14791M13.0758 6.42679L12.2013 2.07415"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeMiterlimit={10}
      />
      <path
        d="M9.43778 1.99178H3.20616C3.04625 1.98179 2.84635 2.08673 2.7614 2.22665C2.74891 2.24414 2.73641 2.25914 2.72642 2.27663L1.25472 4.95767C0.97237 5.38244 1.00235 6.06957 1.31968 6.49184C1.63701 6.91411 2.2167 7.15398 2.91132 7.15398H3.04874C4.48047 7.17147 5.18259 6.37191 5.23256 6.42688C5.60486 6.84665 6.35195 7.15398 7.03159 7.15398H7.16901C7.97857 7.15398 8.72817 6.81167 9.2304 6.28196M6.10459 2.07424L5.23006 6.42688M9.15044 1.7644V6.52682"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeMiterlimit={10}
      />
      <path
        d="M2.49158 7.17139V15.5344C2.49158 16.1265 2.93384 16.6113 3.47604 16.6113H14.8099C15.3521 16.6113 15.7944 16.1265 15.7944 15.5344V7.17139"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeMiterlimit={10}
      />
      <path d="M15.75 13.5H2.25" stroke="currentColor" strokeWidth={1.2} />
    </svg>
  );
}
export function CompetitorsIcon() {
  return <Icon component={CompetitorsSvg} />;
}

function HouseholdsSvg() {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3727_754)">
        <path
          d="M7.25829 16.5V11.2345C7.25829 10.9563 7.4754 10.7284 7.74102 10.7284H10.2563C10.5219 10.7284 10.739 10.9563 10.739 11.2345V16.5M16.1946 6.74868L9.63961 1.72309C9.24927 1.42564 8.74806 1.42564 8.36002 1.72309L1.80272 6.74868C1.54172 6.95018 1.43778 7.28602 1.5371 7.60747C1.63873 7.93131 1.91128 8.14001 2.23695 8.14001H2.85133V15.5261C2.85133 16.049 3.26015 16.4784 3.76136 16.4784H14.2383C14.7395 16.4784 15.1483 16.0514 15.1483 15.5261V8.14001H15.7627C16.086 8.14001 16.3609 7.93131 16.4625 7.60747C16.5618 7.28602 16.4602 6.94778 16.1992 6.74868H16.1946Z"
          stroke="currentColor"
          strokeWidth={1.2}
          strokeMiterlimit={10}
        />
        <path d="M15 8.25H2.25" stroke="currentColor" strokeWidth={1.2} />
      </g>
      <defs>
        <clipPath id="clip0_3727_754">
          <rect width={18} height={18} fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function HouseholdsIcon() {
  return <Icon component={HouseholdsSvg} />;
}

function IncomeWorkingSvg() {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.6875 14.0625C5.68921 14.0592 9.67351 14.5892 13.5353 15.6382C14.0805 15.7867 14.625 15.3817 14.625 14.8162V14.0625M2.8125 3.375V3.9375C2.8125 4.08668 2.75324 4.22976 2.64775 4.33525C2.54226 4.44074 2.39918 4.5 2.25 4.5H1.6875M1.6875 4.5V4.21875C1.6875 3.753 2.0655 3.375 2.53125 3.375H15.1875M1.6875 4.5V11.25M15.1875 3.375V3.9375C15.1875 4.248 15.4395 4.5 15.75 4.5H16.3125M15.1875 3.375H15.4688C15.9345 3.375 16.3125 3.753 16.3125 4.21875V11.5312C16.3125 11.997 15.9345 12.375 15.4688 12.375H15.1875M1.6875 11.25V11.5312C1.6875 11.755 1.77639 11.9696 1.93463 12.1279C2.09286 12.2861 2.30747 12.375 2.53125 12.375H2.8125M1.6875 11.25H2.25C2.39918 11.25 2.54226 11.3093 2.64775 11.4148C2.75324 11.5202 2.8125 11.6633 2.8125 11.8125V12.375M15.1875 12.375V11.8125C15.1875 11.6633 15.2468 11.5202 15.3523 11.4148C15.4577 11.3093 15.6008 11.25 15.75 11.25H16.3125M15.1875 12.375H2.8125M11.25 7.875C11.25 8.47174 11.0129 9.04403 10.591 9.46599C10.169 9.88795 9.59674 10.125 9 10.125C8.40326 10.125 7.83097 9.88795 7.40901 9.46599C6.98705 9.04403 6.75 8.47174 6.75 7.875C6.75 7.27826 6.98705 6.70597 7.40901 6.28401C7.83097 5.86205 8.40326 5.625 9 5.625C9.59674 5.625 10.169 5.86205 10.591 6.28401C11.0129 6.70597 11.25 7.27826 11.25 7.875ZM13.5 7.875H13.506V7.881H13.5V7.875ZM4.5 7.875H4.506V7.881H4.5V7.875Z"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function IncomeWorkingIcon() {
  return <Icon component={IncomeWorkingSvg} />;
}

export function IncomeSvg() {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.8125 4.5V5.0625C2.8125 5.21168 2.75324 5.35476 2.64775 5.46025C2.54226 5.56574 2.39918 5.625 2.25 5.625H1.6875M1.6875 5.625V5.34375C1.6875 4.878 2.0655 4.5 2.53125 4.5H15.1875M1.6875 5.625V12.375M15.1875 4.5V5.0625C15.1875 5.373 15.4395 5.625 15.75 5.625H16.3125M15.1875 4.5H15.4688C15.9345 4.5 16.3125 4.878 16.3125 5.34375V12.6562C16.3125 13.122 15.9345 13.5 15.4688 13.5H15.1875M1.6875 12.375V12.6562C1.6875 12.88 1.77639 13.0946 1.93463 13.2529C2.09286 13.4111 2.30747 13.5 2.53125 13.5H2.8125M1.6875 12.375H2.25C2.39918 12.375 2.54226 12.4343 2.64775 12.5398C2.75324 12.6452 2.8125 12.7883 2.8125 12.9375V13.5M15.1875 13.5V12.9375C15.1875 12.7883 15.2468 12.6452 15.3523 12.5398C15.4577 12.4343 15.6008 12.375 15.75 12.375H16.3125M15.1875 13.5H2.8125M11.25 9C11.25 9.59674 11.0129 10.169 10.591 10.591C10.169 11.0129 9.59674 11.25 9 11.25C8.40326 11.25 7.83097 11.0129 7.40901 10.591C6.98705 10.169 6.75 9.59674 6.75 9C6.75 8.40326 6.98705 7.83097 7.40901 7.40901C7.83097 6.98705 8.40326 6.75 9 6.75C9.59674 6.75 10.169 6.98705 10.591 7.40901C11.0129 7.83097 11.25 8.40326 11.25 9ZM13.5 9H13.506V9.006H13.5V9ZM4.5 9H4.506V9.006H4.5V9Z"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function IncomeIcon() {
  return <Icon component={IncomeSvg} />;
}

function PopulationSvg() {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5 15.75C16.5 13.7961 15.3451 12.0898 13.636 11.1867C12.8146 10.7518 11.8695 10.5 10.8582 10.5H7.13963C6.1305 10.5 5.181 10.7518 4.36177 11.1867C2.65487 12.0898 1.5 13.794 1.5 15.75H16.5Z"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.625 2.25C10.8983 2.25 12.75 4.09945 12.75 6.375C12.75 8.65055 10.9005 10.5 8.625 10.5C6.34945 10.5 4.5 8.65055 4.5 6.375C4.5 4.09945 6.34945 2.25 8.625 2.25Z"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeMiterlimit={10}
      />
    </svg>
  );
}
export function PopulationIcon() {
  return <Icon component={PopulationSvg} />;
}

function PotentialSvg() {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7943 11.6407C13.1451 11.4012 13.5567 11.2658 13.9812 11.2503C14.4058 11.2349 14.8261 11.3399 15.1934 11.5533C15.5608 11.7667 15.8602 12.0798 16.0571 12.4563C16.2539 12.8328 16.3401 13.2573 16.3058 13.6807C15.4059 13.9953 14.4501 14.1176 13.5 14.04C13.4971 13.19 13.2523 12.3576 12.7943 11.6415C12.3877 11.0038 11.8269 10.479 11.1637 10.1156C10.5005 9.75223 9.7563 9.56199 9.00005 9.5625C8.24393 9.56211 7.49992 9.75242 6.83685 10.1158C6.17377 10.4792 5.61305 11.0039 5.20655 11.6415M13.4993 14.0392L13.5 14.0625C13.5 14.2312 13.491 14.3978 13.4723 14.562C12.1113 15.3428 10.5691 15.7525 9.00005 15.75C7.37255 15.75 5.8448 15.318 4.5278 14.562C4.50852 14.3884 4.49925 14.2139 4.50005 14.0392M4.50005 14.0392C3.55027 14.1197 2.59498 13.9978 1.6958 13.6815C1.66156 13.2582 1.74785 12.8338 1.94467 12.4574C2.1415 12.0811 2.44083 11.7681 2.80805 11.5547C3.17528 11.3413 3.5954 11.2362 4.01984 11.2516C4.44428 11.267 4.85571 11.4021 5.20655 11.6415M4.50005 14.0392C4.50274 13.1893 4.74877 12.3577 5.20655 11.6415M11.25 5.0625C11.25 5.65924 11.013 6.23153 10.591 6.65349C10.1691 7.07545 9.59679 7.3125 9.00005 7.3125C8.40331 7.3125 7.83102 7.07545 7.40906 6.65349C6.9871 6.23153 6.75005 5.65924 6.75005 5.0625C6.75005 4.46576 6.9871 3.89347 7.40906 3.47151C7.83102 3.04955 8.40331 2.8125 9.00005 2.8125C9.59679 2.8125 10.1691 3.04955 10.591 3.47151C11.013 3.89347 11.25 4.46576 11.25 5.0625ZM15.75 7.3125C15.75 7.53411 15.7064 7.75354 15.6216 7.95828C15.5368 8.16302 15.4125 8.34904 15.2558 8.50574C15.0991 8.66244 14.9131 8.78674 14.7083 8.87155C14.5036 8.95635 14.2842 9 14.0625 9C13.8409 9 13.6215 8.95635 13.4168 8.87155C13.212 8.78674 13.026 8.66244 12.8693 8.50574C12.7126 8.34904 12.5883 8.16302 12.5035 7.95828C12.4187 7.75354 12.375 7.53411 12.375 7.3125C12.375 6.86495 12.5528 6.43573 12.8693 6.11926C13.1858 5.80279 13.615 5.625 14.0625 5.625C14.5101 5.625 14.9393 5.80279 15.2558 6.11926C15.5723 6.43573 15.75 6.86495 15.75 7.3125ZM5.62505 7.3125C5.62505 7.53411 5.5814 7.75354 5.4966 7.95828C5.41179 8.16302 5.28749 8.34904 5.13079 8.50574C4.97409 8.66244 4.78807 8.78674 4.58333 8.87155C4.37859 8.95635 4.15916 9 3.93755 9C3.71594 9 3.49651 8.95635 3.29177 8.87155C3.08703 8.78674 2.90101 8.66244 2.74431 8.50574C2.58761 8.34904 2.46331 8.16302 2.3785 7.95828C2.2937 7.75354 2.25005 7.53411 2.25005 7.3125C2.25005 6.86495 2.42784 6.43573 2.74431 6.11926C3.06077 5.80279 3.49 5.625 3.93755 5.625C4.3851 5.625 4.81432 5.80279 5.13079 6.11926C5.44726 6.43573 5.62505 6.86495 5.62505 7.3125Z"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function PotentialIcon() {
  return <Icon component={PotentialSvg} />;
}

function RentSvg() {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.62094 9.61558L1.65301 8.86578L1.6535 10.0902L1.65366 10.502C1.65366 10.5021 1.65366 10.5021 1.65366 10.5021C1.65366 10.5022 1.65366 10.5022 1.65366 10.5023C1.65374 11.0662 1.94218 11.5711 2.33545 11.9815C2.73317 12.3965 3.28409 12.7657 3.93202 13.0734C5.23048 13.69 7.00775 14.102 9.00368 14.102C10.9584 14.102 12.7028 13.7069 13.9931 13.1119C14.6372 12.8149 15.1879 12.4589 15.5948 12.0595C15.9965 11.6653 16.3017 11.184 16.3478 10.6413L16.3489 10.6286L16.3494 10.6159L16.3531 10.5274L16.3536 10.5154L16.3537 10.5033L16.3546 10.0906L16.3573 8.86325L15.3871 9.61504C14.029 10.6674 11.7047 11.402 9.00368 11.402C6.30311 11.402 3.97909 10.6677 2.62094 9.61558ZM9.00368 3.60208C11.2012 3.60208 13.161 4.08922 14.55 4.84683C15.9616 5.61681 16.6537 6.58192 16.6537 7.50204V10.502C16.6537 11.4222 15.9616 12.3873 14.55 13.1573C13.161 13.9149 11.2012 14.402 9.00368 14.402C6.84576 14.402 4.9164 13.9323 3.53186 13.1974C2.12845 12.4525 1.40824 11.5118 1.35674 10.6104L1.35366 10.4941V7.50204C1.35366 6.58191 2.0457 5.61681 3.45734 4.84683C4.8463 4.08922 6.8061 3.60208 9.00368 3.60208ZM9.00368 3.90208C7.00775 3.90208 5.23048 4.31409 3.93202 4.93071C3.28409 5.2384 2.73317 5.60763 2.33545 6.02261C1.94213 6.433 1.65366 6.93801 1.65366 7.50204C1.65366 8.06607 1.94213 8.57109 2.33545 8.98149C2.73317 9.39647 3.28409 9.7657 3.93202 10.0734C5.23048 10.69 7.00775 11.102 9.00368 11.102C10.9996 11.102 12.7769 10.69 14.0753 10.0734C14.7233 9.7657 15.2742 9.39647 15.6719 8.98148C16.0652 8.57109 16.3537 8.06607 16.3537 7.50204C16.3537 6.93801 16.0652 6.433 15.6719 6.02261C15.2742 5.60763 14.7233 5.2384 14.0753 4.93071C12.7769 4.31409 10.9996 3.90208 9.00368 3.90208Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={1.2}
      />
    </svg>
  );
}
export function RentIcon() {
  return <Icon component={RentSvg} />;
}

function SpendingsSvg() {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.6875 6.1875H16.3125M1.6875 6.75H16.3125M3.9375 10.6875H8.4375M3.9375 12.375H6.1875M3.375 14.625H14.625C15.0726 14.625 15.5018 14.4472 15.8182 14.1307C16.1347 13.8143 16.3125 13.3851 16.3125 12.9375V5.0625C16.3125 4.61495 16.1347 4.18573 15.8182 3.86926C15.5018 3.55279 15.0726 3.375 14.625 3.375H3.375C2.92745 3.375 2.49822 3.55279 2.18176 3.86926C1.86529 4.18573 1.6875 4.61495 1.6875 5.0625V12.9375C1.6875 13.3851 1.86529 13.8143 2.18176 14.1307C2.49822 14.4472 2.92745 14.625 3.375 14.625Z"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function SpendingsIcon() {
  return <Icon component={SpendingsSvg} />;
}

function TrafficSvg() {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3727_839)">
        <path
          d="M10.5 3C10.5 3.82843 9.82843 4.5 9 4.5C8.17157 4.5 7.5 3.82843 7.5 3C7.5 2.17157 8.17157 1.5 9 1.5C9.82843 1.5 10.5 2.17157 10.5 3Z"
          stroke="currentColor"
          strokeWidth={1.2}
        />
        <path
          d="M4.53585 8.137L4.72558 7.56779L4.72558 7.56779L4.53585 8.137ZM6.16732 8.68082L5.97758 9.25003L5.97758 9.25003L6.16732 8.68082ZM6.76261 9.94225L6.20261 9.72686L6.20261 9.72686L6.76261 9.94225ZM5.82752 12.3735L6.38753 12.5889L6.38753 12.5889L5.82752 12.3735ZM13.4642 8.137L13.2744 7.56779L13.2744 7.56779L13.4642 8.137ZM11.8327 8.68082L12.0224 9.25003L12.0224 9.25003L11.8327 8.68082ZM11.2374 9.94225L11.7974 9.72686L11.7974 9.72686L11.2374 9.94225ZM12.1725 12.3735L11.6125 12.5889L11.6125 12.5889L12.1725 12.3735ZM7.81813 13.3183L8.33907 13.616L8.33907 13.616L7.81813 13.3183ZM9 11.25L9.52095 10.9524C9.41412 10.7654 9.21531 10.65 9 10.65C8.78469 10.65 8.58588 10.7654 8.47905 10.9524L9 11.25ZM12.8599 5.92292L12.7342 5.33624L12.7342 5.33624L12.8599 5.92292ZM11.4367 6.22789L11.5625 6.81457L11.5625 6.81457L11.4367 6.22789ZM6.56326 6.22789L6.68898 5.64121L6.68898 5.64121L6.56326 6.22789ZM5.14009 5.92292L5.01437 6.5096L5.14009 5.92292ZM10.1819 13.3183L9.66093 13.616L9.66093 13.616L10.1819 13.3183ZM11.2788 6.26144L11.1573 5.67388L11.1573 5.67388L11.2788 6.26144ZM6.7212 6.26144L6.59967 6.849L6.59967 6.849L6.7212 6.26144ZM11.4628 8.82516L11.778 9.33572L11.778 9.33572L11.4628 8.82516ZM11.1137 9.56497L11.7081 9.48369L11.7081 9.48368L11.1137 9.56497ZM6.53719 8.82516L6.22203 9.33572L6.22203 9.33572L6.53719 8.82516ZM6.88633 9.56497L7.48079 9.64626L7.48079 9.64626L6.88633 9.56497ZM4.34611 8.70621L5.97758 9.25003L6.35705 8.11161L4.72558 7.56779L4.34611 8.70621ZM6.20261 9.72686L5.26752 12.1581L6.38753 12.5889L7.32262 10.1576L6.20261 9.72686ZM13.2744 7.56779L11.6429 8.11161L12.0224 9.25003L13.6539 8.70621L13.2744 7.56779ZM10.6774 10.1576L11.6125 12.5889L12.7325 12.1581L11.7974 9.72686L10.6774 10.1576ZM8.33907 13.616L9.52095 11.5477L8.47905 10.9524L7.29718 13.0206L8.33907 13.616ZM12.7342 5.33624L11.311 5.64121L11.5625 6.81457L12.9856 6.5096L12.7342 5.33624ZM6.68898 5.64121L5.26581 5.33624L5.01437 6.5096L6.43755 6.81457L6.68898 5.64121ZM8.47905 11.5477L9.66093 13.616L10.7028 13.0206L9.52095 10.9524L8.47905 11.5477ZM11.311 5.64121C11.2311 5.65834 11.1939 5.6663 11.1573 5.67388L11.4003 6.849C11.4421 6.84036 11.4841 6.83136 11.5625 6.81457L11.311 5.64121ZM6.43755 6.81457C6.51589 6.83136 6.55787 6.84036 6.59967 6.849L6.84274 5.67388C6.80608 5.6663 6.76891 5.65834 6.68898 5.64121L6.43755 6.81457ZM11.1573 5.67388C9.73415 5.96825 8.26585 5.96825 6.84274 5.67388L6.59967 6.849C8.18313 7.17654 9.81687 7.17654 11.4003 6.849L11.1573 5.67388ZM6.85879 14.475C7.47061 14.475 8.03553 14.1472 8.33907 13.616L7.29718 13.0206C7.20729 13.178 7.03998 13.275 6.85879 13.275V14.475ZM11.6125 12.5889C11.7397 12.9196 11.4955 13.275 11.1412 13.275V14.475C12.3377 14.475 13.162 13.2748 12.7325 12.1581L11.6125 12.5889ZM11.6429 8.11161C11.4785 8.16641 11.2961 8.22294 11.1477 8.3146L11.778 9.33572C11.7684 9.34162 11.7715 9.33771 11.8139 9.32167C11.8587 9.30474 11.9193 9.2844 12.0224 9.25003L11.6429 8.11161ZM11.7974 9.72686C11.7584 9.62542 11.7355 9.56566 11.7201 9.52035C11.7056 9.47742 11.7066 9.47257 11.7081 9.48369L10.5192 9.64626C10.5428 9.81914 10.6152 9.9959 10.6774 10.1576L11.7974 9.72686ZM11.1477 8.3146C10.6932 8.59511 10.4469 9.11714 10.5192 9.64626L11.7081 9.48368C11.7001 9.42489 11.7275 9.36689 11.778 9.33572L11.1477 8.3146ZM13.65 7.04669C13.65 7.28312 13.4987 7.49302 13.2744 7.56779L13.6539 8.70621C14.3682 8.4681 14.85 7.79964 14.85 7.04669H13.65ZM5.26752 12.1581C4.83801 13.2748 5.66232 14.475 6.85879 14.475V13.275C6.50445 13.275 6.26033 12.9196 6.38753 12.5889L5.26752 12.1581ZM5.97758 9.25003C6.08068 9.2844 6.14135 9.30474 6.18611 9.32167C6.22851 9.33771 6.23158 9.34162 6.22203 9.33572L6.85235 8.3146C6.70387 8.22294 6.52145 8.16641 6.35705 8.11161L5.97758 9.25003ZM7.32262 10.1576C7.38483 9.99589 7.45715 9.81914 7.48079 9.64626L6.29186 9.48368C6.29338 9.47256 6.29445 9.47742 6.27987 9.52035C6.26449 9.56566 6.24162 9.62542 6.20261 9.72686L7.32262 10.1576ZM6.22203 9.33572C6.27252 9.36689 6.2999 9.42489 6.29186 9.48369L7.48079 9.64626C7.55315 9.11714 7.30678 8.59511 6.85235 8.3146L6.22203 9.33572ZM3.15 7.04669C3.15 7.79964 3.6318 8.4681 4.34611 8.70621L4.72558 7.56779C4.50129 7.49302 4.35 7.28312 4.35 7.04669H3.15ZM4.35 7.04669C4.35 6.697 4.67244 6.43633 5.01437 6.5096L5.26581 5.33624C4.17686 5.1029 3.15 5.93302 3.15 7.04669H4.35ZM9.66093 13.616C9.96447 14.1472 10.5294 14.475 11.1412 14.475V13.275C10.96 13.275 10.7927 13.178 10.7028 13.0206L9.66093 13.616ZM14.85 7.04669C14.85 5.93302 13.8231 5.1029 12.7342 5.33624L12.9856 6.5096C13.3276 6.43633 13.65 6.697 13.65 7.04669H14.85Z"
          fill="currentColor"
        />
        <path
          d="M14.5903 10.875C15.7779 11.4721 16.5 12.2606 16.5 13.125C16.5 14.989 13.1421 16.5 9 16.5C4.85786 16.5 1.5 14.989 1.5 13.125C1.5 12.2606 2.22213 11.4721 3.40973 10.875"
          stroke="currentColor"
          strokeWidth={1.2}
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3727_839">
          <rect width={18} height={18} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function TrafficIcon() {
  return <Icon component={TrafficSvg} />;
}

function WorkingSvg() {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.1875 10.6125V13.8C15.1875 14.6205 14.5973 15.327 13.7835 15.435C12.2183 15.6427 10.6215 15.75 9.00004 15.75C7.37854 15.75 5.78179 15.6427 4.21654 15.435C3.40279 15.327 2.81254 14.6205 2.81254 13.8V10.6125M15.1875 10.6125C15.3656 10.4577 15.5081 10.2663 15.6052 10.0512C15.7023 9.83619 15.7517 9.60269 15.75 9.36675V6.5295C15.75 5.71875 15.174 5.01825 14.3723 4.89825C13.5228 4.77106 12.669 4.67425 11.8125 4.608M15.1875 10.6125C15.042 10.7362 14.8725 10.8337 14.6828 10.8975C12.85 11.5056 10.9311 11.8146 9.00004 11.8125C7.01404 11.8125 5.10379 11.4907 3.31729 10.8975C3.13224 10.8359 2.96084 10.7392 2.81254 10.6125M2.81254 10.6125C2.63445 10.4577 2.49196 10.2663 2.39487 10.0512C2.29777 9.83619 2.24836 9.60269 2.25004 9.36675V6.5295C2.25004 5.71875 2.82604 5.01825 3.62779 4.89825C4.47731 4.77106 5.33111 4.67425 6.18754 4.608M11.8125 4.608V3.9375C11.8125 3.48995 11.6348 3.06072 11.3183 2.74426C11.0018 2.42779 10.5726 2.25 10.125 2.25H7.87504C7.42749 2.25 6.99827 2.42779 6.6818 2.74426C6.36533 3.06072 6.18754 3.48995 6.18754 3.9375V4.608M11.8125 4.608C9.94033 4.46331 8.05975 4.46331 6.18754 4.608M9.00004 9.5625H9.00604V9.5685H9.00004V9.5625Z"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function WorkingIcon() {
  return <Icon component={WorkingSvg} />;
}

function BusSvg() {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3909_15762)">
        <path
          d="M2.40527 8.66504V15.1575C2.40527 15.75 2.84777 16.235 3.39027 16.235H14.7303C15.2728 16.235 15.7153 15.75 15.7153 15.1575V8.79004"
          stroke="currentColor"
          strokeWidth={1.2}
          strokeMiterlimit={10}
        />
        <path
          d="M15.9248 8.70752H17.1223C17.5123 8.70752 17.8373 8.40502 17.8373 8.03502V4.95002C17.8373 4.58002 17.5123 4.27502 17.1223 4.27502H15.9248"
          stroke="currentColor"
          strokeWidth={1.2}
          strokeMiterlimit={10}
        />
        <path
          d="M2.24258 8.70752H1.04508C0.655078 8.70752 0.330078 8.40502 0.330078 8.03502V4.95002C0.330078 4.58002 0.655078 4.27502 1.04508 4.27502H2.24258"
          stroke="currentColor"
          strokeWidth={1.2}
          strokeMiterlimit={10}
        />
        <path
          d="M2.41504 8.79001V2.74251C2.41504 2.10001 2.85754 1.57751 3.40004 1.57751H9.08254"
          stroke="currentColor"
          strokeWidth={1.2}
          strokeMiterlimit={10}
        />
        <path
          d="M2.28516 8.71249C4.32016 9.76999 6.63266 10.3675 9.08266 10.3675C11.5327 10.3675 13.8952 9.75749 15.9452 8.67749"
          stroke="currentColor"
          strokeWidth={1.2}
        />
        <path
          d="M15.7505 8.79001V2.74251C15.7505 2.10001 15.308 1.57751 14.7655 1.57751H9.08301"
          stroke="currentColor"
          strokeWidth={1.2}
          strokeMiterlimit={10}
        />
        <path
          d="M2.09777 12.04H4.59277L5.21777 14.04H2.09277"
          stroke="currentColor"
          strokeWidth={1.2}
          strokeLinejoin="round"
        />
        <path
          d="M16.0204 12.04H13.5254L12.9004 14.04H16.0254"
          stroke="currentColor"
          strokeWidth={1.2}
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3909_15762">
          <rect width={18} height={18} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function BusIcon() {
  return <Icon component={BusSvg} />;
}

export const icons_dict = {
  d9: <RentIcon />,
  d1: <PopulationIcon />,
  d6: <HouseholdsIcon />,
  d2: <WorkingIcon />,
  d3: <IncomeWorkingIcon />,
  d4: <IncomeIcon />,
  d7: <CompetitorsIcon />,
  d8: <PotentialIcon />,
  d10: <SpendingsIcon />,
  d5: <TrafficIcon />,
  d11: <BusIcon />,
};
